import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/manga';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9ontjiftmtnfcfh0alg';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    try {
      const form = e.currentTarget as HTMLFormElement;
      const formData = new FormData(form);
      const honeypot = formData.get('website_alt') as string;
      if (honeypot && honeypot.trim()) {
        setSubscribeMsg('订阅成功！感谢您的关注。');
        setEmail('');
        return;
      }
      formData.delete('website_alt');
      const res = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setSubscribeMsg('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试。';
        setSubscribeMsg(msg);
      }
    } catch {
      setSubscribeMsg('订阅失败，请稍后重试。');
    }
  };

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-bold font-heading">古古漫画网</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              {siteInfo.slogan}。{siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-100">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-100">快捷链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link></li>
              <li><Link to="/category/guoman" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">国漫专区</Link></li>
              <li><Link to="/category/riman" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">日漫专区</Link></li>
              <li><Link to="/category/hanman" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">韩漫专区</Link></li>
              <li><Link to="/category/wanjie" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">完结漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-100">订阅更新</h4>
            <p className="text-sm text-background-300 mb-3">订阅我们的邮件，第一时间获取最新漫画更新通知。</p>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-2" data-readdy-form>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                className="w-full px-3 py-2 text-sm rounded-lg bg-secondary-800 border border-secondary-700 text-background-100 placeholder:text-background-400 focus:outline-none focus:border-primary-400 transition-colors"
                required
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <button
                type="submit"
                className="w-full px-4 py-2 text-sm font-medium bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                立即订阅
              </button>
              {subscribeMsg && (
                <p className="text-xs text-accent-400 mt-1">{subscribeMsg}</p>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 古古漫画网 版权所有 | 京ICP备2024XXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}